import React, { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { ScrollView, ScrollViewProps } from 'react-native';
import ScrollContextProvider from './ScrollContextProvider';

export type PRScrollViewOwnProps = {};

export type PRScrollViewProps = PRScrollViewOwnProps & ScrollViewProps;

const PRScrollView = forwardRef<ScrollView, PRScrollViewProps>((props, ref) => {
    const localRef = useRef<ScrollView>(null);

    // Normalize the forwarded ref
    useImperativeHandle(ref, () => localRef.current as ScrollView);

    const renderScrollView = useCallback(
        (onScroll: () => void) => {
            const { children, ...toPass } = props;
            return (
                <ScrollView
                    {...toPass}
                    ref={localRef}
                    testID={toPass.testID || 'pr-scroll-view'}
                    onScroll={(e) => {
                        onScroll();
                        props.onScroll?.(e);
                    }}
                    scrollEventThrottle={30}
                    overScrollMode="never"
                >
                    {children}
                </ScrollView>
            );
        },
        [props],
    );

    return <ScrollContextProvider scrollRef={localRef}>{renderScrollView}</ScrollContextProvider>;
});

export default React.memo(PRScrollView);
